var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6C8.89544 6 8.00001 5.10457 8.00001 4C8.00001 2.89543 8.89544 2 10 2C11.1046 2 12 2.89543 12 4C12 5.10457 11.1046 6 10 6Z",
    fill: "#BA0060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C8.89544 12 8.00001 11.1046 8.00001 10C8.00001 8.89543 8.89544 8 10 8C11.1046 8 12 8.89543 12 10C12 11.1046 11.1046 12 10 12Z",
    fill: "#BA0060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18C8.89544 18 8.00001 17.1046 8.00001 16C8.00001 14.8954 8.89544 14 10 14C11.1046 14 12 14.8954 12 16C12 17.1046 11.1046 18 10 18Z",
    fill: "#BA0060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotted);
export default __webpack_public_path__ + "static/media/three-dotted.03276168251e7ffbd6905f285234692b.svg";
export { ForwardRef as ReactComponent };